export default {
  getURL: 'vodTemplates',
  attributeName: 'vodTemplates',
  canOpen: false,
  isSelectable: true,
  fields: [
    {
      attributeName: 'name',
      canFilter: true,
      label: 'Name',
    },
    {
      attributeName: 'typeToFilter',
      canFilter: true,
      label: 'Video Type',
    },
    {
      attributeName: 'stereoModeTypeToFilter',
      canFilter: true,
      label: 'Stereo Mode',
    },
  ],
};
